import React from "react";
import UrlManagement from "./../../shared/url_management.js";

class Aggregate extends React.Component {
  constructor(props) {
    super(props);
    this.url = new UrlManagement();
    this.applyFilter = this.applyFilter.bind(this);
    this.toggleView = this.toggleView.bind(this);
    this.state = {
      view: "filter--visible"
    };
  }
  applyFilter(filter) {
    const newFilter = {};
    newFilter[`${this.props.agg}`] = filter;
    this.url.manage(newFilter);
    this.props.handleSearch({ agg: this.props.agg, filter });
  }
  toggleView() {
    this.state.view === "filter--hidden"
      ? this.setState({ view: "filter--visible" })
      : this.setState({ view: "filter--hidden" });
  }
  render() {
    return (
      <div className={`filter__${this.props.agg} ${this.state.view}`}>
        <div className={`filter__title`} onClick={this.toggleView}>
          <h4 className="filter__title__name">{this.props.title}</h4>
          <i className="material-icons filter__title__show-icon">&#xE145;</i>
          <i className="material-icons filter__title__minus-icon">&#xE15B;</i>
        </div>
        <ul className="filter__list">
          {this.props.data.map((d, i) => {
            let obj = {};
            obj[this.props.aggType.toLowerCase()] = d.key;

            var checked = <i className="material-icons">&#xE40C;</i>;

            _.forOwn(this.url.getParsedUrl(), (val, key) => {
              let o = {};
              o[key] = val;
              if (_.isEqual(obj, o)) {
                checked = <i className="material-icons">&#xE837;</i>;
                return false;
              }
            });
            return (
              <li
                key={i}
                onClick={() => {
                  this.applyFilter(d.key);
                }}
              >
                {checked}
                <span className="filter__list__name">{decodeURIComponent(d.key)}{" "}</span>
                <span className="count">({d.count})</span>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export { Aggregate as default };
